import React from 'react';
import ModalOuterContainer from '../generic/containers/ModalOuterContainer';
import Button from 'components/shared/generic/button/presentational/Button';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import useTranslate from 'lib/languages/useTranslate';
import { useDispatch } from 'react-redux';
import { hideModal } from 'actions/modal';
import { hideAccountBlockedModal } from 'lib/reducers';

interface AccountBlockedModalProps {
    closeModal: () => void;
    titleText?: string;
    descriptionText?: string;
    confirmText?: string;
}

const AccountBlockedModal = ({
    closeModal,
    confirmText,
    titleText,
    descriptionText,
}: AccountBlockedModalProps) => {
    const translate = useTranslate('accountBlocked');
    const dispatch = useDispatch();

    const handleClose = () => {
        if (closeModal) closeModal();
        dispatch(hideAccountBlockedModal());
        dispatch(hideModal());
    };

    return (
        <ModalOuterContainer customButtons={true}>
            <div className="description">
                <Typography tag="h1">
                    {titleText || translate('titleText')}
                </Typography>
                <Typography>
                    {descriptionText || translate('descriptionText')}
                </Typography>
            </div>
            <Button onClick={handleClose}>
                {confirmText || translate('ok')}
            </Button>
        </ModalOuterContainer>
    );
};

export default AccountBlockedModal;
